import script from "./Initializebbar.vue?vue&type=script&lang=ts&setup=true"
export * from "./Initializebbar.vue?vue&type=script&lang=ts&setup=true"

import "./Initializebbar.vue?vue&type=style&index=0&id=312dd874&scoped=true&lang=css"

import exportComponent from "E:\\code\\my\\bookmark.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-312dd874"]])

export default __exports__